import { gql } from "@apollo/client";

export const QUERY_GET_FORMATTED_INBOUND_RESOURCE_DATA = gql`
  query getFormattedInboundRetailerDataForResource(
    $resourceId: ID!
    $resourceType: RetailerInboundResourceType!
  ) {
    getFormattedInboundRetailerDataForResource(
      resourceId: $resourceId
      resourceType: $resourceType
    )
  }
`;
